import { useState, useEffect } from 'react';

/**
 * Gibt den aktuellen Online-Status des Browsers zurueck.
 *
 * Reagiert in Echtzeit auf 'online'- und 'offline'-Events des Browsers.
 *
 * @returns `true` wenn der Browser online ist, sonst `false`.
 */
export function useOnlineStatus(): boolean {
  const [isOnline, setIsOnline] = useState<boolean>(
    typeof navigator !== 'undefined' ? navigator.onLine : true
  );

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return isOnline;
}
